// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import layers from 'layui-layer'

import "../static/css/iview/iview.scss";
import "../static/css/vant.css";
import './assets/scss/main.scss'; //公共的scss

import common from '../static/common.js'


Vue.use(layers)

Vue.prototype.$layer=layers;
Vue.prototype.common=common
Vue.config.productionTip = false;


router.beforeEach((to, from, next) => {
//	console.log(to, from);
	window.document.title = to.meta.title?to.meta.title:'';
	
	//给页面加一个class类区分背景是白色还是灰色
	const toName = to.meta.bg || '';
	if(toName){
		document.getElementsByTagName('body')[0].classList.add(`page-${toName}`);  //add className
	}else {
//		console.log(document.getElementsByTagName('body')[0].classList);
		document.getElementsByTagName('body')[0].classList.remove('page-bg-gray'); //remove className
	}
	next();
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js